import { render, staticRenderFns } from "./ApprovalStatus.vue?vue&type=template&id=67b9eee4&"
import script from "./ApprovalStatus.vue?vue&type=script&lang=js&"
export * from "./ApprovalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports